import styled, {css} from "styled-components";
import {ILanguageSwitcherDropdownProps} from "../language-switcher-dropdown.component";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div<ILanguageSwitcherDropdownProps>`
  position: absolute;
`;

export const PcBox = styled(DefaultBox)`
  display: ${props => props.isOpen ? "block" : "none"};
  top: 1.5rem;
  width: 32rem;
  margin: 100% 0 0 0;
  padding: 2rem;
  background: ${props => props.theme.colors.backgroundLight};
  border-radius: 5px;
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.5);

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent ${props => props.theme.colors.backgroundLight} transparent;
    transform: translate(-50%, -100%);
  }
`;

export const MobileBox = styled(DefaultBox)`
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 1.5rem;
  background: ${props => props.theme.colors.background};
  overflow-y: auto;
  transform: translateX(-100%);
  transition: transform 0.2s ease-in-out;

  ${props => props.isOpen && css`
    transform: translateX(0);
    z-index: 2;
  `}
`;

export const LanguageSwitcherDropdownDefaultBox = styledByDevice(PcBox, MobileBox);
